
import React, { useEffect } from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';
import { useMapboxInit } from '@/hooks/use-mapbox-init';
import { useMapMarkers } from '@/hooks/use-map-markers';
import { meshLocations } from './meshLocationsData';
import MapLegend from './MapLegend';
import MapErrorDisplay from './MapErrorDisplay';
import { useTheme } from '@/components/theme/ThemeProvider';

interface SecurityMapProps {
  mapboxToken: string;
}

const SecurityMap: React.FC<SecurityMapProps> = ({ mapboxToken }) => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  const mapStyle = isDark ? 'mapbox://styles/mapbox/dark-v11' : 'mapbox://styles/mapbox/light-v11';
  
  const { mapContainer, map, mapLoaded, mapError } = useMapboxInit(mapboxToken, meshLocations, mapStyle);
  
  // Setup map markers
  useMapMarkers(map, meshLocations, mapLoaded);
  
  // Debug log to track marker loading
  useEffect(() => {
    if (mapLoaded) {
      console.log('Map loaded, markers should be visible now');
    }
  }, [mapLoaded]);

  if (mapError) {
    return <MapErrorDisplay error={mapError} />;
  }

  return (
    <div className="relative w-full h-full">
      <div ref={mapContainer} className="absolute inset-0" />
      <MapLegend locations={meshLocations} />
    </div>
  );
};

export default SecurityMap;
